import router from "../router/routes";

// Common APIs
const state = {
    errorAndSuccessMessage: "",
    toasts: [],
};

const mutations = {
    CHECK_ERROR_AND_SUCCESS_MESSAGE(state, Message) {
        state.errorAndSuccessMessage = Message;
      },                                
  addToast(state, toast) {
    state.toasts.push(toast);
    // console.log('addToast-',state,toast)
  },
  clearToast(state, title) {
    // console.log('clearToast-',state,title)
    setTimeout(() => {
      if (title != undefined) {
        const index = state.toasts.findIndex((toast) => toast.title === title); // find toast
        state.toasts.splice(index, 1); // remove toast from array
      } else {
        state.toasts.splice(0, 1); // remove toast from array
      }
    }, 5000);
  },
  clearToast2(state, title) {
    if (title != undefined) {
      const index = state.toasts.findIndex((toast) => toast.title === title); // find toast
      state.toasts.splice(index, 1); // remove toast from array
    } else {
      state.toasts.splice(0, 1); // remove toast from array
    }
  },
};

const actions = {
    checkErrorAndSendToast({ commit, rootGetters }, response) {
        commit("CHECK_ERROR_AND_SUCCESS_MESSAGE", response[0]);
        console.log("message-1-", response);
        // console.log("check-1-", response[1]);
        const message = response[0];
        var lan = rootGetters["whichLanguage"].Status
  
        if (response[1] == "error") {
          if (message == undefined) {
            commit("addToast", {
              title: "Server Error",
              type: "error_1",
              message: lan.May_server_working_please_try_again_after_few_moment
            });
            commit(
              "clearToast",
              lan.May_server_working_please_try_again_after_few_moment
            );
            return;
          } else if (message.statusText == "Unauthorized") {
            commit("addToast", {
              title: "Faild",
              type: "error_1",
              message: message.data.message,
            });
            commit("clearToast", message.data.message);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            alert(lan.Your_login_session_has_been_expired);
            router.go();
          } else if (message.statusText == "Unauthenticated") {
            // commit("addToast", {
            //   title: "Faild",
            //   type: "error_1",
            //   message: message.data.message,
            // });
            // commit("clearToast", message.data.message);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            alert(lan.Your_login_session_has_been_expired);
            router.go();
          } else if (message.status === 429) {
            commit("addToast", {
              title: "Faild",
              type: "error_1",
              message: message.statusText + ", " + lan.try_few_moment_later,
            });
            commit("clearToast", message.statusText + ", " + lan.try_few_moment_later);
            return;
          } else if (message.status === 500) {
            commit("addToast", {
              title: "Faild",
              type: "error_1",
              message: message.statusText + ", " + lan.try_few_moment_later,
            });
            commit("clearToast", message.statusText + ", " + lan.try_few_moment_later);
            // router.push("*");
            return;
          }
          // commit("addToast", {
          //   title: "Faild",
          //   type: "error_1",
          //   message: message.data.message,
          // });
          // setTimeout(() => {
          //   commit("clearToast", message.data.message);
          // }, 5000);
          else if (
            (message.data.message == "Error validation" ||
              message.data.message == "Error Validation") &&
            message.data.data
          ) {
            const errorData = message.data.data;
  
            Object.keys(errorData).forEach((key) => {
              const errorArray = errorData[key];
              if (Array.isArray(errorArray)) {
                commit("addToast", {
                  title: "Faild",
                  type: "error_1",
                  message: `${key} error :- ` + errorArray[0] + ", type again",
                });
                // setTimeout(() => {
                commit(
                  "clearToast",
                  `${key} error :- ` + errorArray[0] + ", type again"
                );
                // }, 10000);
                console.log(`${key} Errors:`, errorArray);
              }
            });
          } else if (message.status == 404) {
            if (message.data.message == "Quote does not exists.") {
              commit("addToast", {
                title: "Not Found",
                type: "error_1",
                message:
                  message.data.message +
                  lan.May_be_this_quote_canceled_by_KonferenceBokarna_Or_Customer,
              });
              commit(
                "clearToast",
                message.data.message +
                  lan.May_be_this_quote_canceled_by_KonferenceBokarna_Or_Customer
              );
              return;
            } 
            else if (message.data.data == "Quote Id Not Found") {
              commit("addToast", {
                title: "Not Found",
                type: "error_1",
                message: message.data.data
              });
              commit("clearToast", message.data.data);
              return;
            } 
            else {
              commit("addToast", {
                title: message.statusText,
                type: "error_1",
                message: message.data.message
                  ? message.data.message
                  : message.statusText +
                    lan.May_server_are_not_working_please_try_again_after_few_moment,
              });
              commit(
                "clearToast",
                message.data.message
                  ? message.data.message
                  : message.statusText +
                      lan.May_server_are_not_working_please_try_again_after_few_moment
              );
              return;
            }
          } else {
            commit("addToast", {
              title: "Faild",
              type: "error_1",
              message: message.data.message,
            });
            commit("clearToast", message.data.message);
          }
        } else {

          var lan = rootGetters["whichLanguageName"]
          var checkLanguage = 'en' in message.data.message
          var filterMessage = checkLanguage ? lan == 'English' ? message.data.message['en'] : message.data.message['sw'] : message.data.message
          commit("addToast", {
            title: "Success",
            type: "success_1",
            message: filterMessage,
          });
          commit("clearToast", filterMessage);
        }
      },
};

const getters = {

};

export default {
  state,
  mutations,
  actions,
  getters,
};
